import * as React from 'react';
import { Container, } from 'react-bootstrap';
import { BsExclamationCircleFill } from 'react-icons/bs';
import { IoIosCheckmarkCircle, IoIosCloseCircle } from 'react-icons/io';
import { ACCEPTABLE, NOT_ACCEPTABLE, USABLE, } from '../../libs/dataLib';

interface Ats2019AcceptabilityIconProps {
  description: string;
  small?: boolean;
  overridden?: boolean;
};

export const Ats2019AcceptabilityIcon: React.FC<Ats2019AcceptabilityIconProps> = ({ description, small, overridden }) => {
  return (
    <Container className='px-0' style={{ cursor: 'pointer' }}>
      {description
        ? <span className='d-flex justify-content-center'>
          {overridden
            ? <BsExclamationCircleFill size={small ? 15 : 17} className='text-info' data-testid="Ats2019AcceptabilityIcon-Acceptable-Override" />
            : description === ACCEPTABLE
              ? <IoIosCheckmarkCircle size={small ? 17 : 19} color='green' data-testid="Ats2019AcceptabilityIcon-Acceptable" />
              : description === USABLE
                ? <IoIosCheckmarkCircle size={small ? 17 : 19} color='#f0ad4e' data-testid="Ats2019AcceptabilityIcon-Usable" />
                : description === NOT_ACCEPTABLE
                  ? <IoIosCloseCircle size={small ? 18 : 20} color='red' data-testid="Ats2019AcceptabilityIcon-Not-Acceptable" />
                  : 'N/A'}
        </span>
        : "N/A"}
    </Container>
  )
};